<template>
  <div>
    <v-card>
      <v-toolbar
        class="white--text"
        color="indigo"
        style="position: sticky; top: 0px; z-index: 1"
        dense
      >
        <v-toolbar-title>Impostazioni Turni</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="newTurno"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Nuovo Turno</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickSaveTurni"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </template>
          <span>Salva Turni</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="dialogVisible = true"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="primary">mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>Profili Turni</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickChiudi"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-data-table
        :items="turni.filter((item) => item.validita == 1)"
        :headers="headers"
      >
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="modifyTurno(item)"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-1"
              >
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="item.validita = 0"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-1"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.seleziona`]="{ item }">
          <v-checkbox
            color="primary"
            v-model="item.schedulabile"
            :true-value="1"
            :false-value="0"
          ></v-checkbox>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="newVisible" width="500">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>{{
            modify ? "Modifica Turno" : "Nuovo Turno"
          }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickSaveNew"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-5"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeNew" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>

        <v-card-text class="mt-5 px-0">
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Codice Turno"
                  class="ma-1"
                  v-model="tempTurno.cod_turno"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Durata"
                  class="ma-1"
                  v-model="tempTurno.durata_minuti"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Unita minima"
                  class="ma-1"
                  v-model="tempTurno.unita_minima_minuti"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Ora Inizio"
                  class="ma-1"
                  v-model="tempTurno.ora_inizio"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Ora Fine"
                  class="ma-1"
                  v-model="tempTurno.ora_fine"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Intervallo pre inizio"
                  class="ma-1"
                  v-model="tempTurno.intervallo_pre_inizio_minuti"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Intervallo post fine"
                  class="ma-1"
                  v-model="tempTurno.intervallo_post_fine_minuti"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Anticipo Inizio"
                  class="ma-1"
                  v-model="tempTurno.anticipo_inizio_minuti"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Posticipo Fine"
                  class="ma-1"
                  v-model="tempTurno.posticipo_fine_minuti"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVisible" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Profili Turni</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickSave"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-5"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialogVisible = false"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-5"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>

        <v-data-table :headers="headersProfili" :items="profili">
          <template v-slot:[`item.checkbox`]="{ item }">
            <v-checkbox
              v-model="item.dichiara"
              dense
              :true-value="0"
              :false-value="1"
            >
            </v-checkbox>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "ImpostazioniTurni",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      nextTempId: 1,
      modify: false,
      newVisible: false,
      dialogVisible: false,
      loading: false,
      turni: [],
      profili: [],
      turniProfili: [],
      tempTurno: {
        id_turno: -1,
        cod_turno: "",
        ora_inizio: "",
        ora_fine: "",
        durata_minuti: 0,
        intervallo_pre_inizio_minuti: 0,
        intervallo_post_fine_minuti: 0,
        anticipo_fine_minuti: 0,
        unita_minima_minuti: 0,
        validita: 1,
        temp_id: 0,
      },
      headers: [
        {
          text: "",
          value: "modifica",
        },
        {
          text: "Codice Turno",
          value: "cod_turno",
        },
        {
          text: "Ora Inizio",
          value: "ora_inizio",
        },
        {
          text: "Ora Fine",
          value: "ora_fine",
        },
        {
          text: "Durata",
          value: "durata_minuti",
        },
        {
          text: "Intervallo pre inizio",
          value: "intervallo_pre_inizio_minuti",
        },
        {
          text: "Intervallo post fine",
          value: "intervallo_post_fine_minuti",
        },
        {
          text: "Anticipo Inizio",
          value: "anticipo_inizio_minuti",
        },
        {
          text: "Posticipo fine",
          value: "posticipo_fine_minuti",
        },
        {
          text: "Unita minima",
          value: "unita_minima_minuti",
        },
        {
          text: "Schedulabile",
          sortable: false,
          value: "seleziona",
        },
        {
          text: "",
          value: "elimina",
        },
      ],
      headersProfili: [
        {
          text: "Nome Profilo",
          value: "des_profilo_utente",
        },
        {
          text: "Deve Dichiarare Turni",
          value: "checkbox",
        },
      ],
    };
  },
  mounted() {
    this.inizializza();
  },
  methods: {
    async inizializza() {
      this.loading = true;

      const request3 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request3).then((res) => {
        if (res.status === 200) {
          for (let i = 0; i < res.data.result.turno_codici.length; i++) {
            this.turni.push(Object.assign({}, res.data.result.turno_codici[i]));
          }
          this.removeSeconds();
        }
      });

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          for (let i = 0; i < res.data.length; i++) {
            this.profili.push(Object.assign({}, res.data[i]));
          }
        }
      });

      const request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofiliturni",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request2).then((res) => {
        if (res.status === 200) {
          this.turniProfili = Array.from(res.data.result.turni_profili);
          for (let i = 0; i < this.profili.length; i++) {
            this.profili[i].dichiara = false;
            for (let i2 = 0; i2 < res.data.result.turni_profili.length; i2++) {
              if (
                this.profili[i].id_profilo_utente ==
                res.data.result.turni_profili[i2].id_profilo
              ) {
                this.profili[i].dichiara = true;
              }
            }
          }
          this.loading = false;
        }
      });
    },
    removeSeconds() {
      for (let i = 0; i < this.turni.length; i++) {
        this.turni[i].ora_inizio =
          this.turni[i].ora_inizio.split(":")[0] +
          ":" +
          this.turni[i].ora_inizio.split(":")[1];
        this.turni[i].ora_fine =
          this.turni[i].ora_fine.split(":")[0] +
          ":" +
          this.turni[i].ora_fine.split(":")[1];
      }
    },
    addSeconds() {
      for (let i = 0; i < this.turni.length; i++) {
        this.turni[i].ora_inizio += ":00";
        this.turni[i].ora_fine += ":00";
      }
    },
    newTurno() {
      this.modify = false;
      this.newVisible = true;
    },
    modifyTurno(item) {
      this.tempTurno = Object.assign({}, item);
      this.modify = true;
      this.newVisible = true;
    },
    async clickSave() {
      var found = false;
      for (let i = 0; i < this.profili.length; i++) {
        found = false;
        for (let i2 = 0; i2 < this.turniProfili.length; i2++) {
          if (
            this.profili[i].id_profilo_utente ==
            this.turniProfili[i2].id_profilo
          ) {
            if (this.profili[i].dichiara) {
              found = true;
            } else {
              this.turniProfili[i2].validita = 0;
            }
          }
        }
        if (!found && this.profili[i].dichiara) {
          this.turniProfili.push({
            id_turno_profilo: -1,
            id_profilo: this.profili[i].id_profilo_utente,
            validita: 1,
          });
        }
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setturnoprofilo",
          turni_profili: this.turniProfili,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.response) {
          this.turniProfili = null;
          this.turniProfili = Array.from(res.data.result.Table1);
          this.$refs.SnackbarQV.print(
            "success",
            "Profili turni salvati con successo"
          );
          this.loading = false;
        } else {
          this.$refs.SnackbarQV.print("orange", "Profili turni non salvati");
        }
      });

      this.dialogVisible = false;
    },
    closeNew() {
      this.tempTurno = {
        id_turno: -1,
        cod_turno: "",
        ora_inizio: "",
        ora_fine: "",
        durata_minuti: 0,
        intervallo_pre_inizio_minuti: 0,
        intervallo_post_fine_minuti: 0,
        anticipo_fine_minuti: 0,
        unita_minima_minuti: 0,
        validita: 1,
        temp_id: this.nextTempId,
      };
      this.newVisible = false;
    },
    clickSaveNew() {
      if (this.modify) {
        for (let i = 0; i < this.turni.length; i++) {
          if (
            this.turni[i].id_turno != -1 &&
            this.turni[i].id_turno == this.tempTurno.id_turno
          ) {
            this.turni[i] = Object.assign({}, this.tempTurno);
            break;
          } else if (
            this.turni[i].id_turno == -1 &&
            this.turni[i].temp_id == this.tempTurno.temp_id
          ) {
            this.turni[i] = Object.assign({}, this.tempTurno);
            break;
          }
        }
      } else {
        this.turni.push(Object.assign({}, this.tempTurno));
      }
      this.tempTurno = {
        id_turno: -1,
        cod_turno: "",
        ora_inizio: "",
        ora_fine: "",
        durata_minuti: 0,
        intervallo_pre_inizio_minuti: 0,
        intervallo_post_fine_minuti: 0,
        anticipo_fine_minuti: 0,
        unita_minima_minuti: 0,
        validita: 1,
        temp_id: this.nextTempId,
      };
      this.nextTempId += 1;
      this.newVisible = false;
    },
    async clickSaveTurni() {
      this.loading = true;

      this.addSeconds();

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setturnocodice",
          turni: this.turni,
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print("success", "Turni salvati con successo");
        } else {
          this.$refs.SnackbarQV.print("orange", "Turni non salvati");
        }
      });

      const request3 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      await this.$store.dispatch("api", request3).then((res) => {
        if (res.status === 200) {
          this.turni = [];
          for (let i = 0; i < res.data.result.turno_codici.length; i++) {
            this.turni.push(Object.assign({}, res.data.result.turno_codici[i]));
          }
          this.removeSeconds();
        }
      });

      this.loading = false;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
  },
};
</script>